import React from 'react';
import RecruitmentContent from '../components/RecruitmentContent/RecruitmentContent';
import CtaSection from '../components/CtaSection/CtaSection';

const RecruitmentPage = () => {
  return (
    <>
      <RecruitmentContent />
      <CtaSection />
    </>
  );
};

export default RecruitmentPage;
